export default __webpack_public_path__ + "static/media/SelfServiceKiosk.1d5f7cdb.jpeg";